module.exports = __webpack_public_path__ + "img/3a031633f6c2479f2970b7303f3c2456.png";